import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { useSSRContext } from '../../../components/app/ssr-context';

//https://reactrouter.com/web/guides/server-rendering/adding-app-specific-context-information

interface RedirectWithStatusProps {
  to?: Location | string; // string path or Location object
  statusCode?: number; // optional HTTP status code for SSR
}

export const RedirectWithStatus: FunctionComponent<RedirectWithStatusProps> = ({ to, statusCode }) => {
  const ssrContext = useSSRContext();

  // --- SSR: set status and URL, but don't render <Navigate> ---
  if (ssrContext) {
    if (statusCode) {
      ssrContext.statusCode = statusCode;
    }
    if (to) {
      // Handle both string and Location objects
      ssrContext.url = typeof to === 'string' ? to : to.pathname + (to.search ? `?${to.search}` : '') + (to.hash ? `#${to.hash}` : '');
    }
    return null; // Don't render <Navigate> on server
  }

  // --- Client: use <Navigate> for client-side navigation ---
  return <Navigate to={to ?? ''} replace />;
};
